import React, { useEffect, useState } from "react";
import { Form, message } from "antd";
import { SaveButton, InputText, CancelButton, ModalComponent, trans, SelectWithSearch } from "@comps/components"
import { makeRequest, makeRequestStateless, getErrorProps } from "@utils/helpers";
import { updateDataReq, getAllcountriesReq } from "../requests";
import { Commons, Const } from "../../../constants";
import { createSelectList } from '@comps/commonFunctions';
import { makeFieldLabel } from "@utils/fieldTooltips";
import { masterTooltips } from "../../../../common/masterTooltips";
const langKey = Const["city"].lngKey
const fieldLabel = makeFieldLabel(masterTooltips.lookup, { namespace: "lookup", label: (key) => trans(`${langKey}.${key}`) });
const formName = "updateCity";

const UpdateCity = (props) => {
  const [loader, setLoader] = useState(false);
  const [saveLoader, setSaveLoader] = useState(false);
  const [errors, setErrors] = useState([]);
  const [countries, setCountries] = useState([]);
  const [form] = Form.useForm();
  useEffect(() => {
    setFormData()
    makeRequestStateless(getAllcountriesReq, false, onGetCountries, false)
    // eslint-disable-next-line
  }, []);
  const onGetCountries = (response) => {
    setCountries(createSelectList(response.countries))
  }
  const setFormData = () => {
    if (!props) {
      return;
    }

    form.setFieldsValue(props.record);
  }
  const onSubmit = (data) => {
    setSaveLoader(true)
    data.id = props.record.id;
    const payload = { city: data };
    //payload.id = props.record.id;
    makeRequest(setLoader, updateDataReq, payload, onSuccess, onError);
  }

  const onSuccess = (data, res) => {
    setSaveLoader(false)
    message.success("Saved successfully");
    props.onCompleted(data.citys.data);
  }

  const onError = (err, res) => {
    setSaveLoader(false)
    message.error(res.response.data.message);
  }

  //-----------------------
  // ------------------------------------
  // Start footer buttons array
  // ------------------------------------

  const footer = [
    <SaveButton loading={ saveLoader } form={ formName } key="create_button" htmlType="submit" />,
    <CancelButton key="close_button" onClick={ () => props.onCompleted(false) } />
  ];

  // ------------------------------------
  // Eend footer buttons array
  // ------------------------------------

  return (
    <ModalComponent top={ 20 } width={ 600 } maskClosable={ false }
      mainTitle={ trans(Commons[props.disabled ? 'view' : 'update']) } subTitle={ trans(`${langKey}.moduleName`) }
      visible={ true } footer={ footer } onCancel={ () => props.onCompleted(false) }>
      <Form { ...formLayout } form={ form } name={ formName } onFinish={ onSubmit } scrollToFirstError>
        <Form.Item name="name" rules={ rules.name } label={ fieldLabel("name", trans(`${langKey}.name`)) }
          className="da-mb-16"
          { ...getErrorProps(errors['name']) } size="small"
        >
          <InputText placeholder={ trans(`${langKey}.name`) } />
        </Form.Item>

        <Form.Item name="state_id" label={ fieldLabel("state_id", trans(`${langKey}.state`)) } rules={ rules.state_id } className="da-mb-16"
          { ...getErrorProps(errors['state_id']) }
        >
          <SelectWithSearch
            placeholder={ trans(`${langKey}.state`) }
            options={ createSelectList(props.states) }
          />
        </Form.Item>
      </Form>
    </ModalComponent>
  )
}

export default UpdateCity

const rules = {
  name: [
    { required: true, message: trans(`${langKey}.name.req`) },
  ],
  state_id: [
    { required: true, message: trans(`${langKey}.state.req`) },
  ],
};

const formLayout = {
  // layout: "horizontal",
  labelCol: { span: 6 },
  wrapperCol: { span: 14, offset: 2 },
  labelAlign: "left"
}